import { useState } from 'react';
import { User } from '../App';
import SuperAdminSidebar from './SuperAdminSidebar';
import SuperAdminOverview from './super-admin/SuperAdminOverview';
import ClientsManagement from './super-admin/ClientsManagement';
import ERPMasters from './super-admin/ERPMasters';
import APITemplates from './super-admin/APITemplates';
import PlansManagement from './super-admin/PlansManagement';
import SubscriptionBilling from './super-admin/SubscriptionBilling';
import SuperAdminLogs from './super-admin/SuperAdminLogs';
import SuperAdminSettings from './super-admin/SuperAdminSettings';

interface SuperAdminDashboardProps {
  user: User;
  onLogout: () => void;
}

export type SuperAdminView = 
  | 'overview'
  | 'clients'
  | 'erp-masters'
  | 'api-templates'
  | 'plans'
  | 'subscription'
  | 'logs'
  | 'settings';

export default function SuperAdminDashboard({ user, onLogout }: SuperAdminDashboardProps) {
  const [currentView, setCurrentView] = useState<SuperAdminView>('overview');

  const renderContent = () => {
    switch (currentView) {
      case 'overview':
        return <SuperAdminOverview />;
      case 'clients':
        return <ClientsManagement />;
      case 'erp-masters':
        return <ERPMasters />;
      case 'api-templates':
        return <APITemplates />;
      case 'plans':
        return <PlansManagement />;
      case 'subscription':
        return <SubscriptionBilling />;
      case 'logs':
        return <SuperAdminLogs />;
      case 'settings':
        return <SuperAdminSettings />;
      default:
        return <SuperAdminOverview />;
    }
  };

  return (
    <div className="flex h-screen bg-[#F4F5F7]">
      <SuperAdminSidebar
        user={user}
        currentView={currentView}
        onViewChange={setCurrentView}
        onLogout={onLogout}
      />
      <main className="flex-1 overflow-y-auto">
        {renderContent()}
      </main>
    </div>
  );
}
